import { Component, OnInit, ElementRef, Input, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as SecureLS from "secure-ls";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  FormArray,
  Validators,
} from "@angular/forms";
import { customEmailValidator } from "../../utils/email.customvalidator";
import { MatSnackBar, MatDialog } from "@angular/material";
import {
  MatAutocompleteSelectedEvent,
  MatAutocomplete,
} from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import * as password from "secure-random-password";
import { GlobalVariable } from "src/app/config/global";
import { BusinessUnit } from "src/app/model/businessUnit";
import { BusinessunitService } from "src/app/service/businessunit.service";
import { DistrictService } from "src/app/service/district.service";
import { District } from "src/app/model/district";
import { Church } from "src/app/model/church";
import { ChurchService } from "src/app/service/church.service";
import { UnionService } from "src/app/service/union.service";
import { Union } from "src/app/model/union";
import { PaymentService } from "src/app/service/payment.service";
import { invalid } from "@angular/compiler/src/render3/view/util";
import { ConfirmpaymentDialogComponent } from "../confirmpayment-dialog/confirmpayment-dialog.component";
import { ChurchSearchComponent } from "../church-search/church-search.component";
import { Donor } from "src/app/model/donor";
import { DonorService } from "src/app/service/donor.service";
import { DNIType } from "src/app/model/dniType";
import { DnitypeService } from "src/app/service/dnitype.service";
import { EcclesiaService } from "src/app/service/ecclesia.service";
import { DonationType } from "src/app/model/donationType";
import { DonortransactionService } from "src/app/service/donortransaction.service";

const ePaycoURL =
  "https://s3-us-west-2.amazonaws.com/epayco/v1.0/checkoutEpayco.js";
const wompiURL = "https://checkout.wompi.co/widget.js";
@Component({
  selector: "app-myenvelope",
  templateUrl: "./myenvelope.component.html",
  styleUrls: ["./myenvelope.component.scss"],
})
export class MyenvelopeComponent implements OnInit {
  AppName = "";
  isLoading = false;
  isLoadingEcclesia = false;
  errorMessage = "";
  envelopeForm: FormGroup;
  unionSearch: String = "";
  ls: SecureLS;
  @Input() iglesiaSeleccionada: Church;
  // params
  unionParameter;
  businessUnitParameter;
  districtParameter;
  churchParameter;
  // donor information
  donor: Donor;
  dniTypes: DNIType[];
  selectedDNIType = <DNIType>{
    id: "",
  };
  donorHasOldData = false;
  // model
  unions: Union[] = [];
  selectedUnion = <Union>{
    id: "",
  };
  businessUnits: BusinessUnit[] = [];
  selectedBusinessUnit = <BusinessUnit>{
    id: "",
  };
  districts: District[];
  selectedDistrict = <District>{
    id: "",
  };
  churchs: Church[];
  selectedChurch = <Church>{
    id: "",
  };
  // alfoli
  businessUnitsAlfoli: BusinessUnit[] = [];
  districtsAlfoli: District[];
  churchsAlfoli: Church[];
  // ecclesia
  unionsEcclesia: Union[] = [];
  selectedUnionEcclesia = <Union>{
    id: "",
  };
  unionEcclesiaKeyMap = { nombre: "short_name" };
  businessUnitsEcclesia: BusinessUnit[] = [];
  selectedBusinessUnitEcclesia = <BusinessUnit>{
    id: "",
  };
  districtsEcclesia: District[] = [];
  selectedDistrictEcclesia = <District>{
    id: "",
  };
  districtsEcclesiaByBU: District[] = [];
  districtEcclesiaKeyMap = {
    asociacionId: "bu_code",
    distritoId: "district_id",
    descripcion: "code",
    nombre: "name",
    activo: "status",
    asociacionNombre: "bu_name",
    unionId: "union_code",
    unionNombre: "union_short_name",
  };
  churchsEcclesia: Church[] = [];
  selectedChurchEcclesia = <Church>{
    id: "",
  };
  churchsEcclesiaByDistrict: Church[] = [];
  churchEcclesiaKeyMap = {
    asociacionId: "bu_code",
    distritoId: "district_id",
    descripcion: "code",
    nombre: "name",
    activo: "status",
    direccion: "address",
    tesorero: "treasurer_name",
    distritoNombre: "district_name",
    asociacionNombre: "bu_name",
    unionId: "union_code",
    unionNombre: "union_short_name",
    ciudad: "city_name",
  };
  // donations selection
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  allDonationsType: DonationType[] = [];
  donationsLocalCtrl = new FormControl();
  filteredDonationsLocal: Observable<DonationType[]>;
  donationsLocal: DonationType[] = [];
  allDonationsLocal: DonationType[] = [];
  @ViewChild("donationsLocalInput", { static: false })
  donationsLocalInput: ElementRef<HTMLInputElement>;
  @ViewChild("auto", { static: false }) matAutocomplete: MatAutocomplete;
  donationsAsociacionCtrl = new FormControl();
  filteredDonationsAsociacion: Observable<DonationType[]>;
  donationsAsociacion: DonationType[] = [];
  allDonationsAsociacion: DonationType[] = [];
  @ViewChild("donationsAsociacionInput", { static: false })
  donationsAsociacionInput: ElementRef<HTMLInputElement>;
  @ViewChild("auto", { static: false })
  donationsAsociacionMatAutocomplete: MatAutocomplete;
  // transaction
  totalOfferings = 0;
  totalConferenceOfferings = 0;
  totalLocalOfferings = 0;
  totalTransaction = 0;
  // ePayco
  buttonIndex = 7;
  loadAPI: Promise<any>;
  secretIntegrityHash: string = "";

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private donorService: DonorService,
    private dnitypeService: DnitypeService,
    private unionService: UnionService,
    private businessunitService: BusinessunitService,
    private districtService: DistrictService,
    private churchService: ChurchService,
    private paymentService: PaymentService,
    private ecclesiaService: EcclesiaService,
    private donorTransactionService: DonortransactionService
  ) {
    // donations selection
    this.setDonationsSelection();
  }

  ngOnInit() {
    this.AppName = GlobalVariable.APP_NAME;
    this.ls = new SecureLS({ encodingType: "aes" });
    this.initForms();
    this.getParams();
    this.getDNITypes();
    if (this.validateSession()) {
      this.getDonorData();
    }
    this.setAllUnions();
    this.setUnion();
  }

  initForms() {
    this.envelopeForm = this.formBuilder.group({
      union: new FormControl("", [Validators.required]),
      bu: new FormControl("", [Validators.required]),
      district: new FormControl("", [Validators.required]),
      church: new FormControl("", [Validators.required]),
      firstName: new FormControl("", [Validators.required]),
      middleName: new FormControl(""),
      lastName: new FormControl("", [Validators.required]),
      secondLastName: new FormControl(""),
      email: new FormControl("", [Validators.required, customEmailValidator]),
      dniType: new FormControl("", [Validators.required]),
      document: new FormControl("", [
        Validators.required,
        Validators.pattern("\\s*(\\S\\s*){6,}"),
      ]),
      phoneNumber: new FormControl("", [Validators.required]),
      address: new FormControl("", [Validators.required]),
      tithes: new FormControl(),
      offeringsGeneral: new FormControl(),
      offeringsFirst: new FormControl(),
      offerings13th: new FormControl(),
      offeringsInvestment: new FormControl(),
      offeringsSabbathSchool: new FormControl(),
      offeringsBirthday: new FormControl(),
      offeringsGratitude: new FormControl(),
      offerings: new FormControl({
        value: this.totalOfferings,
        disabled: true,
      }),
      offeringsTemple: new FormControl(),
      offeringsRadioTV: new FormControl(),
      offeringsADRA: new FormControl(),
      offeringsOther: new FormControl(),
      offeringsOtherDescription: new FormControl({
        value: "",
        disabled: false,
      }),
      localChurchFields: this.formBuilder.array([]),
      totalTithesOfferings: new FormControl({
        value: this.totalTransaction,
        disabled: true,
      }),
      privacy: new FormControl(false, [Validators.requiredTrue]),
    });
  }

  get fieldsLocalChurch(): FormArray {
    return this.envelopeForm.get("localChurchFields") as FormArray;
  }

  getErrorMessage(component: string) {
    let errorMessage = "";
    switch (component) {
      case "union":
        errorMessage = this.envelopeForm.get("union").hasError("required")
          ? "debe seleccionar su unión"
          : "";
        break;
      case "bu":
        errorMessage = this.envelopeForm.get("bu").hasError("required")
          ? "debe seleccionar su campo"
          : "";
        break;
      case "district":
        errorMessage = this.envelopeForm.get("district").hasError("required")
          ? "debe seleccionar su distrito"
          : "";
        break;
      case "church":
        errorMessage = this.envelopeForm.get("church").hasError("required")
          ? "debe seleccionar su iglesia"
          : "";
        break;
      case "firstName":
        errorMessage = this.envelopeForm.get("firstName").hasError("required")
          ? "debe ingresar su nombre"
          : "";
        break;
      case "lastName":
        errorMessage = this.envelopeForm.get("lastName").hasError("required")
          ? "debe ingresar sus apellidos"
          : "";
        break;
      case "email":
        errorMessage = this.envelopeForm.get("email").hasError("required")
          ? "campo requerido"
          : this.envelopeForm.get("email").hasError("invalidEmail")
          ? "ingresa un correo válido"
          : "";
        break;
      case "dniType":
        errorMessage = this.envelopeForm.get("dniType").hasError("required")
          ? "debe seleccionar un tipo de documento"
          : "";
        break;
      case "document":
        errorMessage = this.envelopeForm.get("document").hasError("required")
          ? "debe ingresar su número de identificación"
          : this.envelopeForm.get("document").hasError("pattern")
          ? "mínimo 6 caracteres"
          : "";
        break;
      case "phoneNumber":
        errorMessage = this.envelopeForm.get("phoneNumber").hasError("required")
          ? "debe ingresar su número de teléfono"
          : "";
        break;
      case "address":
        errorMessage = this.envelopeForm.get("address").hasError("required")
          ? "debe ingresar su dirección física"
          : "";
        break;
      case "offeringsOtherDescription":
        errorMessage = this.envelopeForm
          .get("offeringsOtherDescription")
          .hasError("required")
          ? "campo requerido"
          : "";
        break;
      case "privacy":
        errorMessage = this.envelopeForm.get("privacy").hasError("required")
          ? "Debe aceptar términos y condiciones para poder continuar"
          : "";
        break;
      case "password":
        errorMessage = this.envelopeForm.get("password").hasError("required")
          ? "campo requerido"
          : "";
        break;
    }
    return errorMessage;
  }

  getParams() {
    this.route.paramMap.subscribe((params) => {
      this.unionParameter = params.get("u");
      this.businessUnitParameter = params.get("bu");
      this.districtParameter = params.get("d");
      this.churchParameter = params.get("c");
    });
  }

  setPredefinedParams(type: string) {
    switch (type) {
      case "union":
        this.selectedUnion = this.unions.find(
          (u) => u.id.trim() === this.unionParameter
        );
        if (this.selectedUnion) {
          this.envelopeForm.controls["union"].setValue(this.selectedUnion);
          this.envelopeForm.controls["union"].enable();
          this.getBusinessUnitByUnion();
        }
        break;
      case "businessunit":
        this.selectedBusinessUnit = this.businessUnits.find(
          (bu) => bu.id.trim() === this.businessUnitParameter
        );

        if (this.selectedBusinessUnit) {
          this.envelopeForm.controls["bu"].setValue(this.selectedBusinessUnit);
          this.envelopeForm.controls["bu"].enable();
          this.getDistricsByBU();
        } else {
          if (this.donor && !this.selectedBusinessUnit) {
            this.donorHasOldData = true;
          }
          this.selectedBusinessUnit = <BusinessUnit>{
            id: "",
          };
        }
        break;
      case "district":
        this.selectedDistrict = this.districts.find(
          (d) => d.id.trim() === this.districtParameter
        );
        if (this.selectedDistrict) {
          this.envelopeForm.controls["district"].setValue(
            this.selectedDistrict
          );
          this.envelopeForm.controls["district"].enable();
          this.getChurchsByDistrict();
        }
        break;
      case "church":
        this.selectedChurch = this.churchs.find(
          (c) => c.id.trim() === this.churchParameter
        );
        if (this.selectedChurch) {
          this.envelopeForm.controls["church"].setValue(this.selectedChurch);
          this.envelopeForm.controls["church"].enable();

          // reset payment buttons to update public key
          document.getElementsByTagName("form")[1].innerHTML = "";
          document.getElementsByTagName("form")[2].innerHTML = "";
          this.allDonationsLocal = [];
          this.allDonationsAsociacion = [];
          this.getDonationsTypeByChurch();
        }
        break;
      default:
        break;
    }
  }

  validateSession(): boolean {
    if (localStorage.getItem("auid") === null) {
      this.buttonIndex = 5;
      return false;
    } else {
      this.buttonIndex = 7;
      return true;
    }
  }

  getDNITypes() {
    this.isLoading = true;
    this.dnitypeService.get().subscribe(
      (p) => {
        this.dniTypes = p.results !== undefined ? p.results : [];
      },
      (e) => this.launchMessage(e),
      () => {
        this.isLoading = false;
        if (this.dniTypes.length > 0) {
        }
      }
    );
  }

  /** Event handler when district select component changes */
  dniTypesSelectionChange(event: { value: DNIType }) {
    this.selectedDNIType = event.value;
  }

  /** function to get the current logged in user*/
  getDonorData() {
    this.donor = <Donor>{
      id: "",
    };
    const userid = this.ls.get("auid");
    this.donorService.getDonor(userid).subscribe(
      (p) => {
        this.donor = p.results !== undefined ? p.results[0] : null;
      },
      (e) => this.launchMessage(e),
      () => {
        if (this.donor) {
          //set donor church
          this.setDonorChurchParams();
          //set donor values
          this.envelopeForm.controls["firstName"].setValue(
            this.donor.firstname !== ""
              ? this.donor.firstname
              : this.donor.org_name
          );
          this.envelopeForm.controls["middleName"].setValue(
            this.donor.middlename !== "" ? this.donor.middlename : ""
          );
          this.envelopeForm.controls["lastName"].setValue(
            this.donor.first_lastname !== "" ? this.donor.first_lastname : " "
          );
          this.envelopeForm.controls["secondLastName"].setValue(
            this.donor.second_lastname !== "" ? this.donor.second_lastname : ""
          );
          this.envelopeForm.controls["email"].setValue(this.donor.email);
          this.envelopeForm.controls["document"].setValue(this.donor.id);
          this.envelopeForm.controls["dniType"].setValue(this.donor.dni_type);
          // set DNI type
          this.selectedDNIType = <DNIType>{
            id: this.donor.dni_type,
          };
          this.envelopeForm.controls["phoneNumber"].setValue(
            this.donor.cellphone
          );
          this.envelopeForm.controls["address"].setValue(this.donor.address);
        }
      }
    );
  }

  setDonorChurchParams() {
    this.unionParameter = this.donor.union_code;
    this.businessUnitParameter = this.donor.bu_code;
    this.districtParameter = this.donor.district_id;
    this.churchParameter = this.donor.church_id;
  }

  getAllUnion() {
    this.isLoading = true;
    this.unionService.get().subscribe(
      (p) => {
        this.unions = p.results !== undefined ? p.results : [];
      },
      (e) => this.launchMessage(e),
      () => {
        this.isLoading = false;
        if (this.unions.length > 0 && this.unionParameter) {
          this.setPredefinedParams("union");
          this.unionParameter = null;
        }
      }
    );
  }

  getAllUnionEcclesia() {
    this.isLoading = true;
    var response = [];
    this.ecclesiaService.getUnion().subscribe(
      (p) => {
        response = p.listaItems !== undefined ? p.listaItems : [];
      },
      (e) => this.launchMessage(e),
      () => {
        // change object keys
        this.unionsEcclesia = this.renameKeys(
          response,
          this.unionEcclesiaKeyMap
        );
        this.isLoading = false;
        if (this.unionsEcclesia.length > 0 && this.unionParameter) {
          this.setPredefinedParams("union");
          this.unionParameter = null;
        }
      }
    );
  }

  /** Function to set local union list for select */
  setAllUnions() {
    this.unions = [
      {
        id: "3",
        short_name: "Union Colombiana del Norte",
        name: "Union Colombiana del Norte",
        location: "Colombia",
        division_code: "SUD",
      },
      {
        id: "5",
        short_name: "Union Colombiana del Sur",
        name: "Union Colombiana del Sur",
        location: "Colombia",
        division_code: "SUD",
      },
    ];
  }

  /** Event handler when business unit select component changes */
  unionSelectionChange(event: { value: Union }) {
    this.selectedUnion = event.value;
    // this.envelopeForm.controls["bu"].setValue(null);
    // this.envelopeForm.controls["district"].setValue(null);
    // this.envelopeForm.controls["church"].setValue(null);
    // this.businessUnits = [];
    // this.districts = [];
    // this.churchs = [];
    // this.getBusinessUnitByUnion();
    if (this.selectedUnion.id === "5") {
      this.selectedUnion = <Union>{
        id: "3",
        short_name: "Union Colombiana del Norte",
      };
      this.envelopeForm.controls["union"].setValue(this.selectedUnion);
      window.location.href = "https://mialfoliadventista.org/myenvelope/";
    }
  }

  setUnion() {
    this.selectedUnion = <Union>{
      id: "3",
      short_name: "Union Colombiana del Norte",
    };
    this.envelopeForm.controls["union"].setValue(this.selectedUnion);
    this.getBusinessUnitByUnion();
  }

  getBusinessUnitByUnion() {
    this.isLoading = true;
    var response = [];
    this.businessunitService.getByUnion("AGC111").subscribe(
      (p) => {
        response = p.results !== undefined ? p.results : [];
      },
      (e) => this.launchMessage(e),
      () => {
        this.isLoading = false;
        this.businessUnitsAlfoli = response;
        this.getChurchsByUnionEclessia();
      }
    );
  }

  getChurchsByUnionEclessia() {
    this.isLoading = true;
    this.isLoadingEcclesia = true;
    var response = [];
    this.ecclesiaService.getChurchsByUnion(this.selectedUnion.id).subscribe(
      (p) => {
        response = p.listaItems !== undefined ? p.listaItems : [];
      },
      (e) => this.launchMessage(e),
      () => {
        // change object keys
        this.churchsEcclesia = this.renameKeys(
          response,
          this.churchEcclesiaKeyMap
        );
        // map church accountant info

        // map church accountant info
        this.churchsEcclesia.map((church) => {
          if (
            church.tesoreroItems &&
            church.tesoreroItems[0] &&
            church.tesoreroItems[0].nombre
          ) {
            church.treasurer_name = church.tesoreroItems[0].nombre;
          }
          church.email = this.joinEmails(church.tesoreroItems);
        });
        this.setBusinessUnitsEcclesia();
        this.isLoading = false;
        this.isLoadingEcclesia = false;
      }
    );
  }

  setBusinessUnitsEcclesia() {
    if (this.churchsEcclesia.length > 0) {
      // business units
      const uniqueDataBusinessUnits = this.removeDuplicates(
        this.churchsEcclesia,
        "bu_code"
      );
      uniqueDataBusinessUnits.forEach((church) => {
        const buAlfoli = this.businessUnitsAlfoli.find(
          (bu) => bu.ecclesia7_id === church.bu_code
        );
        this.businessUnitsEcclesia.push({
          id: church.bu_code,
          name: church.bu_name,
          short_name: church.bu_name,
          national_code: "",
          email: buAlfoli ? buAlfoli.email : "",
          address: "",
          phone: "",
          telefax: "",
          website: "",
          location: "",
          resolution: "",
          accountant: "",
          accountant_code: "",
          payment_publickey: buAlfoli ? buAlfoli.payment_publickey : "",
          payment_secretkey: "",
          payment_integrity: buAlfoli ? buAlfoli.payment_integrity : "",
          ecclesia7_id: church.bu_code,
          type: "ecclesia",
        });
      });
      this.mergeBusinessUnitsAlfoliEcclesia();
    }
  }

  mergeBusinessUnitsAlfoliEcclesia() {
    this.businessUnits = [
      ...this.businessUnitsEcclesia,
      ...this.businessUnitsAlfoli.filter((bu) => bu.displayed_alfoli === "1"),
    ];
    if (this.businessUnits.length > 0 && this.businessUnitParameter) {
      this.setPredefinedParams("businessunit");
      this.businessUnitParameter = null;
    }
  }

  /** Event handler when business unit select component changes */
  buSelectionChange(event: { value: BusinessUnit }) {
    this.selectedBusinessUnit = event.value;
    this.envelopeForm.controls["district"].setValue(null);
    this.envelopeForm.controls["church"].setValue(null);
    this.districtsAlfoli = [];
    this.districtsEcclesia = [];
    this.districtsEcclesiaByBU = [];
    this.districts = [];
    this.churchs = [];
    this.allDonationsLocal = [];
    this.allDonationsAsociacion = [];
    // reset payment buttons to update public key
    document.getElementsByTagName("form")[1].innerHTML = "";
    document.getElementsByTagName("form")[2].innerHTML = "";
    // validate the type of Business unit to add or remove validations to District and Church fields
    if (this.selectedBusinessUnit.type === "ecclesia") {
      // district add validators
      this.envelopeForm.controls["district"].setValidators([
        Validators.required,
      ]);
      this.envelopeForm.controls["district"].updateValueAndValidity();
      // church add validators
      this.envelopeForm.controls["church"].setValidators([Validators.required]);
      this.envelopeForm.controls["church"].updateValueAndValidity();
      this.getDistricsByBU();
    } else {
      // district remove validators
      this.envelopeForm.controls["district"].setValidators([]);
      this.envelopeForm.controls["district"].updateValueAndValidity();
      // church remove validators
      this.envelopeForm.controls["church"].setValidators([]);
      this.envelopeForm.controls["church"].updateValueAndValidity();
      this.selectedDistrict.id = this.selectedBusinessUnit.id;
      this.selectedDistrict.name = this.selectedBusinessUnit.short_name;
      this.selectedDistrict.code = this.selectedBusinessUnit.id;
      this.selectedChurch.id = this.selectedBusinessUnit.id;
      this.selectedChurch.name = this.selectedBusinessUnit.short_name;
      this.selectedChurch.code = this.selectedBusinessUnit.id;
      this.selectedChurch.email = this.selectedBusinessUnit.email;
      this.selectedChurch.treasurer_name = this.selectedBusinessUnit.accountant;
    }
  }

  getDistricsByBU() {
    this.isLoading = true;
    this.districtService.getByBU(this.selectedBusinessUnit.id).subscribe(
      (p) => {
        this.districtsAlfoli = p.results !== undefined ? p.results : [];
      },
      (e) => this.launchMessage(e),
      () => {
        this.isLoading = false;
        this.districtsAlfoli = [];
        this.getDistrictsEcclesia();
      }
    );
  }

  getDistrictsEcclesia() {
    this.isLoading = true;
    var response = [];
    this.ecclesiaService
      .getDistrictsByUnionAndBU(
        this.selectedUnion.id,
        this.selectedBusinessUnit.id
      )
      .subscribe(
        (p) => {
          response = p.listaItems !== undefined ? p.listaItems : [];
        },
        (e) => this.launchMessage(e),
        () => {
          // change object keys
          this.districtsEcclesiaByBU = this.renameKeys(
            response,
            this.districtEcclesiaKeyMap
          );
          this.mergeDistricsAlfoliEcclesia();
          this.isLoading = false;
        }
      );
  }

  setDistricsEcclesia() {
    if (this.churchsEcclesia.length > 0) {
      // districts
      const uniqueDataDistricts = this.removeDuplicates(
        this.churchsEcclesia,
        "district_id"
      );
      uniqueDataDistricts.forEach((church) => {
        this.districtsEcclesia.push({
          id: church.district_id,
          code: "",
          name: church.district_name,
          status: "",
          bu_code: church.bu_code,
        });
      });
    }
    if (this.districtsEcclesia.length > 0) {
      this.districtsEcclesiaByBU = this.districtsEcclesia.filter(
        (district) => district["bu_code"] === this.selectedBusinessUnit.id
      );
    }
    this.mergeDistricsAlfoliEcclesia();
  }

  mergeDistricsAlfoliEcclesia() {
    this.districts = [...this.districtsEcclesiaByBU, ...this.districtsAlfoli];
    if (this.districts.length > 0 && this.districtParameter) {
      this.setPredefinedParams("district");
      this.districtParameter = null;
    }
  }

  /** Event handler when district select component changes */
  districtSelectionChange(event: { value: District }) {
    this.selectedDistrict = event.value;
    this.envelopeForm.controls["church"].setValue(null);
    this.churchs = [];
    this.selectedChurch = null;
    this.allDonationsLocal = [];
    this.allDonationsAsociacion = [];
    // reset payment buttons to update public key
    document.getElementsByTagName("form")[1].innerHTML = "";
    document.getElementsByTagName("form")[2].innerHTML = "";
    this.getChurchsByDistrict();
  }

  getChurchsByDistrict() {
    this.isLoading = true;
    this.churchService.getByDistrict(this.selectedDistrict.id).subscribe(
      (p) => {
        this.churchsAlfoli = p.results !== undefined ? p.results : [];
      },
      (e) => this.launchMessage(e),
      () => {
        this.isLoading = false;
        this.churchsAlfoli = [];
        this.setChurchsEcclesia();
      }
    );
  }

  setChurchsEcclesia() {
    if (this.churchsEcclesia.length > 0) {
      this.churchsEcclesiaByDistrict = this.churchsEcclesia.filter(
        (church) => church["district_id"] === this.selectedDistrict.id
      );
    }
    this.mergeChurchsAlfoliEcclesia();
  }

  mergeChurchsAlfoliEcclesia() {
    this.churchs = [...this.churchsEcclesiaByDistrict, ...this.churchsAlfoli];
    if (this.churchs.length > 0 && this.churchParameter) {
      this.setPredefinedParams("church");
      this.churchParameter = null;
    }
  }

  /** Event handler when church select component changes */
  churchSelectionChange(event: { value: Church }) {
    this.selectedChurch = event.value;
    // reset payment buttons to update public key
    document.getElementsByTagName("form")[1].innerHTML = "";
    document.getElementsByTagName("form")[2].innerHTML = "";
    this.allDonationsLocal = [];
    this.allDonationsAsociacion = [];
    this.getDonationsTypeByChurch();
  }

  getDonationsTypeByChurch() {
    this.isLoading = true;
    var response = [];
    this.ecclesiaService
      .getDonationsTypeByChurchAndDate(this.selectedChurch.id, "28/12/2024")
      .subscribe(
        (p) => {
          response = p.listaItems !== undefined ? p.listaItems : [];
        },
        (e) => this.launchMessage(e),
        () => {
          this.allDonationsType = response;
          this.allDonationsLocal = response.filter(
            (donation) => donation["tipoIngreso"] === "LOCAL"
          );
          this.allDonationsAsociacion = response.filter(
            (donation) =>
              donation["tipoIngreso"] === "ASOCIACION" &&
              donation["nombre"] !== "Diezmos" &&
              donation["nombre"] !== "Ofrenda"
          );
          this.setDonationsSelection();
          this.isLoading = false;
        }
      );
  }

  /** Donations selection section*/
  setDonationsSelection() {
    this.filteredDonationsLocal = this.donationsLocalCtrl.valueChanges.pipe(
      startWith(null),
      map((donation: DonationType | null) =>
        donation ? this._filter(donation) : this.allDonationsLocal.slice()
      )
    );
    this.filteredDonationsAsociacion =
      this.donationsAsociacionCtrl.valueChanges.pipe(
        startWith(null),
        map((fruit: DonationType | null) =>
          fruit
            ? this._filterDonationAsociacion(fruit)
            : this.allDonationsAsociacion.slice()
        )
      );
  }

  add(event: MatChipInputEvent): void {}

  remove(donation: DonationType): void {
    const index = this.donationsLocal.indexOf(donation);

    if (index >= 0) {
      this.donationsLocal.splice(index, 1);
      this.removeField(donation.id);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    //add field
    this.addField(event.option.value.id);
    this.donationsLocal.push(event.option.value);
    this.donationsLocalInput.nativeElement.value = "";
    this.donationsLocalCtrl.setValue(null);
  }

  private _filter(value: DonationType): DonationType[] {
    const filterValue = value;

    return this.allDonationsLocal.filter(
      (donation) => donation === filterValue
    );
  }

  addDonationAsociacion(event: MatChipInputEvent): void {}

  removeDonationAsociacion(fruit: DonationType): void {
    const index = this.donationsAsociacion.indexOf(fruit);

    if (index >= 0) {
      this.donationsAsociacion.splice(index, 1);
      this.removeField(fruit.id);
    }
  }

  selectedDonationAsociacion(event: MatAutocompleteSelectedEvent): void {
    //add field
    this.addField(event.option.value.id);
    this.donationsAsociacion.push(event.option.value);
    this.donationsAsociacionInput.nativeElement.value = "";
    this.donationsAsociacionCtrl.setValue(null);
  }

  private _filterDonationAsociacion(value: DonationType): DonationType[] {
    const filterValue = value;

    return this.allDonationsAsociacion.filter((fruit) => fruit === filterValue);
  }

  /**
   * Adds a new field to the dynamic form.
   */
  addField(id: string) {
    this.envelopeForm.addControl(
      id,
      new FormControl("", [Validators.required])
    );
  }

  /**
   * Removes a field from the dynamic form at a specific index.
   * @param index Index of the field to be removed.
   */
  removeField(name: string) {
    this.envelopeForm.removeControl(name);
    this.calculateTotal(this.envelopeForm);
  }
  /** End Donations selection section*/

  calculateTotal(form: FormGroup) {
    if (
      form.value.tithes !== null ||
      form.value.offeringsGeneral !== null ||
      form.value.offeringsFirst !== null ||
      form.value.offerings13th !== null ||
      form.value.offeringsInvestment !== null ||
      form.value.offeringsSabbathSchool !== null ||
      form.value.offeringsBirthday !== null ||
      form.value.offeringsGratitude !== null ||
      form.value.offeringsTemple !== null ||
      form.value.offeringsRadioTV !== null ||
      form.value.offeringsADRA !== null ||
      form.value.offeringsOther !== null
    ) {
      var totalDonationsLocal = 0;
      var totalDonationsAsociacion = 0;
      if (this.donationsLocal.length > 0) {
        this.donationsLocal.forEach((donation) => {
          totalDonationsLocal += form.value[donation.id];
        });
        this.totalLocalOfferings = totalDonationsLocal;
      }
      if (this.donationsAsociacion.length > 0) {
        this.donationsAsociacion.forEach((donation) => {
          totalDonationsAsociacion += form.value[donation.id];
        });
        this.totalConferenceOfferings = totalDonationsAsociacion;
      }

      this.totalTransaction =
        +form.value.tithes +
        +form.value.offeringsGeneral +
        +form.value.offeringsFirst +
        +form.value.offerings13th +
        +form.value.offeringsInvestment +
        +form.value.offeringsSabbathSchool +
        +form.value.offeringsBirthday +
        +form.value.offeringsGratitude +
        +form.value.offeringsTemple +
        +form.value.offeringsRadioTV +
        +form.value.offeringsADRA +
        +form.value.offeringsOther +
        +this.totalLocalOfferings +
        +this.totalConferenceOfferings;
    } else {
      this.totalTransaction = 0;
    }
    if (
      form.value.offeringsGeneral !== null ||
      form.value.offeringsFirst !== null ||
      form.value.offerings13th !== null ||
      form.value.offeringsInvestment !== null ||
      form.value.offeringsSabbathSchool !== null ||
      form.value.offeringsBirthday !== null ||
      form.value.offeringsGratitude !== null
    ) {
      this.totalOfferings =
        form.value.offeringsGeneral +
        form.value.offeringsFirst +
        form.value.offerings13th +
        form.value.offeringsInvestment +
        form.value.offeringsSabbathSchool +
        form.value.offeringsBirthday +
        form.value.offeringsGratitude;
    } else {
      this.totalOfferings = 0;
    }
    if (form.value.offeringsOther !== null && form.value.offeringsOther > 0) {
      this.envelopeForm.controls["offeringsOtherDescription"].setValidators([
        Validators.required,
      ]);
      this.envelopeForm.controls[
        "offeringsOtherDescription"
      ].updateValueAndValidity();
    } else {
      this.envelopeForm.controls["offeringsOtherDescription"].setValidators([]);
      this.envelopeForm.controls[
        "offeringsOtherDescription"
      ].updateValueAndValidity();
    }
  }

  createTransaction(form: FormGroup) {
    if (form.valid) {
      // reset payment buttons to update public key
      document.getElementsByTagName("form")[2].innerHTML = "";
      if (this.isValidAmount()) {
        const dialogRef = this.dialog.open(ConfirmpaymentDialogComponent, {
          width: "450px",
          data: {
            name: this.envelopeForm.value.firstName,
            totalTransaction: this.totalTransaction,
            churchName: this.selectedChurch.name,
            districtName: this.selectedDistrict.name,
            businessUnitName: this.selectedBusinessUnit.short_name,
          },
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.loadAPI = new Promise((resolve) => {
              this.generateReference();
            });
          }
        });
      } else {
        this.launchMessage(
          "El monto total de tu donación debe ser de mínimo $10,000 COP"
        );
      }
    } else {
      let invalidFields = [].slice.call(
        document.getElementsByClassName("ng-invalid")
      );
      if (invalidFields.length > 2) {
        invalidFields[2].focus();
      } else {
        invalidFields[1].focus();
      }
    }
  }

  isValidAmount() {
    if (this.totalTransaction >= 10000) {
      return true;
    } else {
      return false;
    }
  }

  generateReference() {
    let reference = "";
    let message = "";
    reference = password.randomPassword({
      length: 6,
      characters: [password.upper, password.digits],
    });
    // reference = "JPPE86"

    this.paymentService.getValidateIfReferenceExists(reference).subscribe(
      (p) => (message = p.message),
      (e) => this.launchMessage("Generando referencia..."),
      () => {
        // this.isLoading = false;
        if (message === "Exists") {
          this.generateReference();
          this.launchMessage("Generando nueva referencia...");
        } else {
          this.loadWompiScript(reference);
        }
      }
    );
  }

  loadScript() {
    let node = document.createElement("script");
    node.src = ePaycoURL;
    node.setAttribute("class", "epayco-button");
    node.setAttribute(
      "data-epayco-key",
      this.selectedBusinessUnit.payment_publickey
    );
    node.setAttribute("data-epayco-amount", this.totalTransaction.toString());
    node.setAttribute("data-epayco-name", "Mi Alfolí");
    node.setAttribute(
      "data-epayco-description",
      "Devolución de diezmos y ofrendas"
    );
    node.setAttribute("data-epayco-currency", "cop");
    node.setAttribute("data-epayco-country", "co");
    node.setAttribute("data-epayco-test", "true");
    node.setAttribute(
      "data-epayco-response",
      GlobalVariable.BASE_SERVER_URL + "transactionresponse"
    );
    node.setAttribute(
      "data-epayco-confirmation",
      GlobalVariable.BASE_API_URL + GlobalVariable.PAYMENT_CONFIRMATION_URL
    );
    node.setAttribute("data-epayco-extra1", this.selectedDistrict.code);
    node.setAttribute("data-epayco-extra2", this.selectedChurch.code);
    node.setAttribute(
      "data-epayco-extra3",
      this.envelopeForm.value.tithes === null
        ? 0
        : this.envelopeForm.value.tithes
    );
    node.setAttribute("data-epayco-extra4", this.totalOfferings.toString());
    node.setAttribute(
      "data-epayco-extra5",
      this.envelopeForm.value.offeringsTemple === null
        ? 0
        : this.envelopeForm.value.offeringsTemple
    );
    node.setAttribute(
      "data-epayco-extra6",
      this.envelopeForm.value.offeringsADRA === null
        ? 0
        : this.envelopeForm.value.offeringsADRA
    );
    node.setAttribute(
      "data-epayco-extra7",
      this.envelopeForm.value.offeringsOther === null
        ? 0
        : this.envelopeForm.value.offeringsOther
    );
    node.setAttribute(
      "data-epayco-extra8",
      this.envelopeForm.value.offeringsOtherDescription === null ||
        this.envelopeForm.value.offeringsOtherDescription === undefined
        ? " "
        : this.envelopeForm.value.offeringsOtherDescription
    );
    let extra9 =
      this.envelopeForm.value.offeringsGeneral === null
        ? "0"
        : this.envelopeForm.value.offeringsGeneral;
    extra9 += "@";
    extra9 +=
      this.envelopeForm.value.offeringsFirst === null
        ? "0"
        : this.envelopeForm.value.offeringsFirst;
    extra9 += "@";
    extra9 +=
      this.envelopeForm.value.offerings13th === null
        ? "0"
        : this.envelopeForm.value.offerings13th;
    extra9 += "@";
    extra9 +=
      this.envelopeForm.value.offeringsInvestment === null
        ? "0"
        : this.envelopeForm.value.offeringsInvestment;
    extra9 += "@";
    extra9 +=
      this.envelopeForm.value.offeringsSabbathSchool === null
        ? "0"
        : this.envelopeForm.value.offeringsSabbathSchool;
    extra9 += "@";
    extra9 +=
      this.envelopeForm.value.offeringsBirthday === null
        ? "0"
        : this.envelopeForm.value.offeringsBirthday;
    extra9 += "@";
    extra9 +=
      this.envelopeForm.value.offeringsGratitude === null
        ? "0"
        : this.envelopeForm.value.offeringsGratitude;
    node.setAttribute("data-epayco-extra9", extra9);
    document.getElementsByTagName("form")[1].appendChild(node);
    node.onload = () => {
      document.getElementsByTagName("button")[this.buttonIndex];
      setTimeout(this.clickEpaycoButton, 1000);
    };
  }

  clickEpaycoButton() {
    document.getElementsByTagName("button")[this.buttonIndex].click();
  }

  loadWompiScript(reference: string) {
    this.isLoading = true;
    // const reference = password.randomPassword({
    //   length: 6,
    //   characters: [password.upper, password.digits],
    // });

    this.paymentService
      .getSecretIntegrityEncrypt(
        reference,
        (this.totalTransaction * 100).toString(),
        "COP",
        this.selectedBusinessUnit.payment_integrity
      )
      .subscribe(
        (p) => {
          this.secretIntegrityHash =
            p.results !== undefined ? p.results[0].hash : "";
        },
        (e) => this.launchMessage(e),
        () => {
          this.isLoading = false;

          let node = document.createElement("script");
          node.src = wompiURL;
          node.setAttribute("data-render", "button");
          node.setAttribute(
            "data-public-key",
            this.selectedBusinessUnit.payment_publickey
          );
          node.setAttribute("data-currency", "COP");
          node.setAttribute(
            "data-amount-in-cents",
            (this.totalTransaction * 100).toString()
          );
          node.setAttribute("data-reference", reference);
          node.setAttribute(
            "data-redirect-url",
            GlobalVariable.BASE_SERVER_URL + "transactionresponse"
          );
          node.setAttribute(
            "data-signature:integrity",
            this.secretIntegrityHash
          );
          document.getElementsByTagName("form")[2].appendChild(node);
          node.onload = () => {
            document.getElementsByTagName("button")[this.buttonIndex];
            // setTimeout(this.clickWompiButton, 1000)
            this.createPayment(reference);
          };
        }
      );
  }

  clickWompiButton() {
    document.getElementsByTagName("button")[this.buttonIndex].click();
  }

  createPayment(reference: string) {
    let message = "";
    const submission = this.buildJSONToPostDonorTransaction(reference);
    // update Donor church information if Old
    if (this.donorHasOldData) {
      this.updateChurch();
    }
    this.donorTransactionService.post(submission).subscribe(
      (p) => (message = p.message),
      (e) =>
        this.launchMessage(
          "Su alfolí no se pudo procesar en estos momentos. Por favor intente nuevamente"
        ),
      () => {
        this.isLoading = false;

        if (message === "Payment was created") {
          this.clickWompiButton();
        } else {
          this.launchMessage(
            "Su alfolí no se pudo procesar en estos momentos. Por favor intente nuevamente"
          );
        }
      }
    );
  }

  createPaymentWompiConfirmation(reference: string) {
    let message = "";
    const submission = this.buildJSONToPostWompiConfirmation(reference);
    // update Donor church information if Old
    if (this.donorHasOldData) {
      this.updateChurch();
    }
    this.donorTransactionService.postWompiConfirmation(submission).subscribe(
      (p) => (message = p.message),
      (e) =>
        this.launchMessage(
          "Su alfolí no se pudo procesar en estos momentos. Por favor intente nuevamente"
        ),
      () => {
        this.isLoading = false;

        this.router.navigate(["/transactionresponse"]);
      }
    );
  }

  updateChurch() {
    let message = "";
    const submission = this.buildJSONToPutDonorChurch();
    this.donorService.putUpdateChurch(submission).subscribe(
      (p) => (message = p.message),
      (e) =>
        this.launchMessage(
          "La actualización no se pudo procesar en estos momentos. Por favor intente nuevamente"
        ),
      () => {
        this.isLoading = false;
        if (message === "Updated") {
          this.launchMessage("Actualización realizada con éxito.");
        } else {
          this.launchMessage(
            "La actualización no se pudo procesar en estos momentos. Por favor intente nuevamente"
          );
        }
      }
    );
  }

  /** this method builds the json using the data enter in the form */
  buildJSONToPutDonorChurch(): any {
    const x = {
      id: this.donor.id,
      union_code: this.selectedUnion.id,
      bu_code: this.selectedBusinessUnit.id,
      district_id: this.selectedDistrict.id,
      church_id: this.selectedChurch.id,
    };
    return x;
  }

  /** this method builds the json for DonorTransaction using the data enter in the form */
  buildJSONToPostDonorTransaction(reference: string): any {
    const now = new Date();
    const month = now.getMonth() + 1;
    const x = {
      union_code: this.selectedUnion.id,
      union_name: this.selectedUnion.short_name,
      bu_code: this.selectedBusinessUnit.id,
      bu_name: this.selectedBusinessUnit.short_name,
      bu_email: this.selectedBusinessUnit.email,
      distric_id: this.selectedDistrict.id
        ? this.selectedDistrict.id
        : this.selectedBusinessUnit.id,
      district_name: this.selectedDistrict.name
        ? this.selectedDistrict.name
        : this.selectedBusinessUnit.short_name,
      district_code: this.selectedDistrict.code
        ? this.selectedDistrict.code
        : this.selectedBusinessUnit.id,
      church_id: this.selectedChurch.id
        ? this.selectedChurch.id
        : this.selectedBusinessUnit.id,
      church_name: this.selectedChurch.name
        ? this.selectedChurch.name
        : this.selectedBusinessUnit.short_name,
      church_code: this.selectedChurch.code
        ? this.selectedChurch.code
        : this.selectedBusinessUnit.id,
      church_email: this.selectedChurch.email
        ? this.selectedChurch.email
        : this.selectedBusinessUnit.email,
      church_treasure_name: this.selectedChurch.treasurer_name,
      transaction_id: "",
      reference: reference,
      transaction_date:
        now.getFullYear() +
        "-" +
        month +
        "-" +
        now.getDate() +
        " " +
        now.getHours() +
        ":" +
        now.getMinutes() +
        ":" +
        now.getSeconds(),
      response: "AWAITING",
      customer_doctype: this.selectedDNIType.id,
      customer_document: this.envelopeForm.value.document,
      customer_name: this.envelopeForm.value.firstName,
      customer_middlename: this.envelopeForm.value.middleName,
      customer_lastname: this.envelopeForm.value.lastName,
      customer_secondlastname: this.envelopeForm.value.secondLastName,
      customer_email: this.envelopeForm.value.email,
      customer_phone: this.envelopeForm.value.phoneNumber,
      customer_movil: this.envelopeForm.value.phoneNumber,
      customer_country: "",
      customer_city: "",
      customer_address: this.envelopeForm.value.address,
      customer_ip: "",
      customer_logged: "0",
      tithe:
        this.envelopeForm.value.tithes === null
          ? 0
          : this.envelopeForm.value.tithes,
      general_offering: this.totalOfferings.toString(),
      payment_o_general:
        this.envelopeForm.value.offeringsGeneral === null
          ? "0"
          : this.envelopeForm.value.offeringsGeneral,
      payment_o_first:
        this.envelopeForm.value.offeringsFirst === null
          ? "0"
          : this.envelopeForm.value.offeringsFirst,
      payment_o_13th:
        this.envelopeForm.value.offerings13th === null
          ? "0"
          : this.envelopeForm.value.offerings13th,
      payment_o_investment:
        this.envelopeForm.value.offeringsInvestment === null
          ? "0"
          : this.envelopeForm.value.offeringsInvestment,
      payment_o_sabbathschool:
        this.envelopeForm.value.offeringsSabbathSchool === null
          ? "0"
          : this.envelopeForm.value.offeringsSabbathSchool,
      payment_o_birthday:
        this.envelopeForm.value.offeringsBirthday === null
          ? "0"
          : this.envelopeForm.value.offeringsBirthday,
      payment_o_gratitude:
        this.envelopeForm.value.offeringsGratitude === null
          ? "0"
          : this.envelopeForm.value.offeringsGratitude,
      conference_offering: this.totalConferenceOfferings,
      conference_offering_description: this.transformAsociacionDonations(),
      local_offering: this.totalLocalOfferings,
      local_offering_description: this.transformLocalDonations(),
      suscription_id: "",
      invoice: "",
      payment_description: "",
      amount: this.totalTransaction.toString(),
      amount_available: "0",
      tax: "0",
      currency_code: "",
      bank_name: "",
      card_number: "",
      franchise: "",
      quotas: "",
      response_code: "",
      approval_code: "",
      signature: "",
      ecclesia7_status:
        this.selectedBusinessUnit.type === "ecclesia" ? "0" : "2",
      ecclesia7_date: "",
      ecclesia7_response: "",
    };
    return x;
  }

  /** this method builds the json using the data enter in the form and selected assets */
  buildJSONToPostPayment(reference: string): any {
    const now = new Date();
    const month = now.getMonth() + 1;
    const x = {
      bu_code: this.selectedBusinessUnit.id,
      union_code: this.selectedUnion.id,
      bu_short_name: this.selectedBusinessUnit.short_name,
      bu_email: this.selectedBusinessUnit.email,
      district_name: this.selectedDistrict.name,
      church_email: this.selectedChurch.email,
      church_name: this.selectedChurch.name,
      district_code: this.selectedDistrict.code,
      church_code: this.selectedChurch.code,
      tithe:
        this.envelopeForm.value.tithes === null
          ? 0
          : this.envelopeForm.value.tithes,
      general_offering: this.totalOfferings.toString(),
      temple_offering:
        this.envelopeForm.value.offeringsTemple === null
          ? 0
          : this.envelopeForm.value.offeringsTemple,
      radiotv_offering:
        this.envelopeForm.value.offeringsRadioTV === null
          ? 0
          : this.envelopeForm.value.offeringsRadioTV,
      adra_offering:
        this.envelopeForm.value.offeringsADRA === null
          ? 0
          : this.envelopeForm.value.offeringsADRA,
      specific_offering:
        this.envelopeForm.value.offeringsOther === null
          ? 0
          : this.envelopeForm.value.offeringsOther,
      description_specific_offering:
        this.envelopeForm.value.offeringsOtherDescription === null ||
        this.envelopeForm.value.offeringsOtherDescription === undefined
          ? " "
          : this.envelopeForm.value.offeringsOtherDescription,
      payment_o_general:
        this.envelopeForm.value.offeringsGeneral === null
          ? "0"
          : this.envelopeForm.value.offeringsGeneral,
      payment_o_first:
        this.envelopeForm.value.offeringsFirst === null
          ? "0"
          : this.envelopeForm.value.offeringsFirst,
      payment_o_13th:
        this.envelopeForm.value.offerings13th === null
          ? "0"
          : this.envelopeForm.value.offerings13th,
      payment_o_investment:
        this.envelopeForm.value.offeringsInvestment === null
          ? "0"
          : this.envelopeForm.value.offeringsInvestment,
      payment_o_sabbathschool:
        this.envelopeForm.value.offeringsSabbathSchool === null
          ? "0"
          : this.envelopeForm.value.offeringsSabbathSchool,
      payment_o_birthday:
        this.envelopeForm.value.offeringsBirthday === null
          ? "0"
          : this.envelopeForm.value.offeringsBirthday,
      payment_o_gratitude:
        this.envelopeForm.value.offeringsGratitude === null
          ? "0"
          : this.envelopeForm.value.offeringsGratitude,
      customer_doctype: "CC",
      customer_document: this.envelopeForm.value.document,
      customer_name: this.envelopeForm.value.firstName,
      customer_lastname: this.envelopeForm.value.lastName,
      customer_email: this.envelopeForm.value.email,
      customer_phone: this.envelopeForm.value.phoneNumber,
      customer_movil: this.envelopeForm.value.phoneNumber,
      customer_country: "",
      customer_city: "",
      customer_address: "",
      customer_ip: "",
      reference: reference,
      invoice: "",
      payment_description: "",
      amount: this.totalTransaction.toString(),
      amount_available: "0",
      tax: "0",
      currency_code: "",
      bank_name: "",
      card_number: "",
      franchise: "",
      quotas: "",
      response: "AWAITING",
      response_code: "",
      approval_code: "",
      transaction_id: "",
      transaction_date:
        now.getFullYear() +
        "-" +
        month +
        "-" +
        now.getDate() +
        " " +
        now.getHours() +
        ":" +
        now.getMinutes() +
        ":" +
        now.getSeconds(),
      signature: "",
    };
    return x;
  }

  /** this method builds the json for WompiConfirmation using the data enter in the form */
  buildJSONToPostWompiConfirmation(reference: string): any {
    const now = new Date();
    const month = now.getMonth() + 1;
    const x = {
      event: "transaction.updated",
      data: {
        transaction: {
          id: "1234-1610641025-49203",
          amount_in_cents: this.totalTransaction,
          reference: reference,
          customer_email: this.envelopeForm.value.email,
          currency: "COP",
          payment_method_type: "CARD",
          redirect_url: GlobalVariable.BASE_SERVER_URL + "transactionresponse",
          status: "APPROVED",
          shipping_address: null,
          payment_link_id: null,
          payment_source_id: null,
        },
      },
      environment: "prod",
      signature: {
        properties: [
          "transaction.id",
          "transaction.status",
          "transaction.amount_in_cents",
        ],
        checksum:
          "3476DDA50F64CD7CBD160689640506FEBEA93239BC524FC0469B2C68A3CC8BD0",
      },
      timestamp: now.getTime(),
      sent_at: now.toISOString(),
    };
    return x;
  }

  // function to transform asociacion donations to a description format ID:NAME:AMOUNT@ID:NAME:AMOUNT
  transformAsociacionDonations() {
    var description = "";
    // set Diezmos at the begining
    const tithe = this.allDonationsType.find(
      (donationsType) => donationsType.nombre.trim() === "Diezmos"
    );
    const titheValue =
      this.envelopeForm.value.tithes === null
        ? "0"
        : this.envelopeForm.value.tithes;
    description += tithe.id + ":Diezmos:" + titheValue + "@";
    if (this.donationsAsociacion.length > 0) {
      this.donationsAsociacion.forEach((donation) => {
        description +=
          donation.id +
          ":" +
          donation.nombre +
          ":" +
          this.envelopeForm.value[donation.id] +
          "@";
      });
    }
    description = description.slice(0, -1);
    return description;
  }
  // function to transform local donations to a description format ID:NAME:AMOUNT@ID:NAME:AMOUNT
  transformLocalDonations() {
    var description = "";
    if (this.donationsLocal.length > 0) {
      this.donationsLocal.forEach((donation) => {
        description +=
          donation.id +
          ":" +
          donation.nombre +
          ":" +
          this.envelopeForm.value[donation.id] +
          "@";
      });
      description = description.slice(0, -1);
    }
    return description;
  }

  // call dialog box to search churchs
  searchByChurch() {
    const dialogRef = this.dialog.open(ChurchSearchComponent, {
      width: "650px",
    });
    const sub = dialogRef.componentInstance.data.subscribe((data) => {
      this.setValues(data);
    });
    dialogRef.afterClosed().subscribe(() => {
      sub.unsubscribe();
    });
    // reset payment buttons to update public key
    document.getElementsByTagName("form")[1].innerHTML = "";
    document.getElementsByTagName("form")[2].innerHTML = "";
  }

  // function to set all church info dropdows based on the user search selection
  setValues(data: Church) {
    this.unionParameter = data.union_code;
    this.businessUnitParameter = data.bu_code;
    this.districtParameter = data.district_id;
    this.churchParameter = data.id;

    this.getAllUnion();
  }

  /** function that rename the keys from all the objects of an array */
  renameKeys(array, keyMap) {
    return array.map((obj) => {
      const newObj = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const newKey = keyMap[key] || key;
          newObj[newKey] = obj[key];
        }
      }
      return newObj;
    });
  }

  /** function thata remove duplicate objects from an array based on a key */
  removeDuplicates(array, key) {
    return array.filter(
      (obj, index, self) => index === self.findIndex((o) => o[key] === obj[key])
    );
  }

  /** Joins emails from tesoreroItems array into a single string */
  joinEmails(tesoreroItems: any[]): string {
    if (!tesoreroItems || !Array.isArray(tesoreroItems)) {
      return "";
    }
    return tesoreroItems
      .map((item) => (item && item.email ? item.email : ""))
      .filter((email) => email)
      .join("; ");
  }

  /** Launch message of the snackBar component */
  launchMessage(message: string) {
    this.errorMessage = "";
    this.isLoading = false;
    const action = "OK";
    this.snackBar.open(message, action, {
      duration: 5000,
    });
  }
}
